export const EXSBPRICEGROUP_CREATE_RESET = 'EXSBPRICEGROUP_CREATE_RESET'
export const EXSBPRICEGROUP_CREATE_SET_CREATED = 'EXSBPRICEGROUP_CREATE_SET_CREATED'
export const EXSBPRICEGROUP_CREATE_SET_ERROR = 'EXSBPRICEGROUP_CREATE_SET_ERROR'
export const EXSBPRICEGROUP_CREATE_SET_VIOLATIONS = 'EXSBPRICEGROUP_CREATE_SET_VIOLATIONS'
export const EXSBPRICEGROUP_CREATE_TOGGLE_LOADING = 'EXSBPRICEGROUP_CREATE_TOGGLE_LOADING'
